import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { alertActions, commonActions, certboxActions } from '../../../../../store/actions'
import moment from 'moment'
import Alert from '../../../../../module/alert/Alert'
import { commons } from '../../../../../hook/common'
import PdfViewer from '../../../../../module/pdf/PdfViewer'

/*
   시험성적서, 계약 form
 */
const CertboxForm5 = (props) => {
  const [state, setState] = useState({})
  const [commoncode, setCommoncode] = useState({})
  const [isShowPdf, setIsShowPdf] = useState(false) //삭제 버튼 표시 여부
  const [showResponse, setShowResponse] = useState()
  const [showFileNm, setShowFileNm] = useState()
  const [blobResponse, setBlobResponse] = useState()
  const [docid, setDocid] = useState()
  const [crtCd, setCrtCd] = useState()
  const [brno, setBrno] = useState()
  const [oldYn, setOldYn] = useState()
  const [fileId, setFileId] = useState()
  const [printYn, setPrintYn] = useState()

  const gnrlInfoCn = JSON.parse(props.data?.gnrlInfoCn)

  useEffect(() => {
    props.getCommonCode({ mainCd: ['CRT_FORM_TP', 'CRT_PERFORM_TP', 'CRT_SUBMIS_TP', 'CRT_DV'] })
  }, [])

  useEffect(() => {
    setCommoncode({
      ...commoncode,
      ...props.commoncode,
    })

    setState({
      ...state,
      docFormatNm: props.commoncode?.CRT_FORM_TP?.find((co) => co.cd === props.data?.docFormat)?.cdName,
      docTypeNm: props.commoncode?.CRT_SUBMIS_TP?.find((co) => co.cd === props.data?.submisType)?.cdName,
      submissionNm: props.commoncode?.CRT_SUBMIS_TP?.find((co) => co.cd === props.data?.submission)?.cdName,
      crtNm: props.commoncode?.CRT_DV?.find((co) => co.cd === props.data?.crtCd)?.cdName,
    })
  }, [props.commoncode])


  console.log('props.commoncode = ', props.commoncode)
  console.log('props.commoncode.CRT_DV = ', props.commoncode['CRT_DV'])
  /*
    console.log('props = ', props);
    console.log('props.commoncode?.CRT_DV = ', props.commoncode?.CRT_DV?.cd);
    console.log('props.data = ', props.data);
    console.log('state = ', state);
    */

  const onShowOut = (e) => {
    e.preventDefault()
  }

  const eventHandler = (e, crtSeq) => {
    e.preventDefault()
    document.querySelectorAll('.attach-file').forEach((a)=>{
      if(a.id == crtSeq){
        a.className = 'attach-file active'
      }else{
        a.className = 'attach-file'
      }
    })
  }

  /**
   * pdf download
   * //TODO someday 상위 컴퍼넌트로 끌어올릴 것
   */
  let onPdfDown = (crtCd, docid, brno, fileObj) => {
    let fileList = []
    if (fileObj) {
      fileList.push(fileObj)
    }
    if (!fileList || !fileList.length) {
      props.error({ message: 'PDF 파일이 존재하지 않습니다.' })
      return
    }
    fileList.forEach((val, idx, arr) => {
      if (crtCd === '03' && fileList[idx].readYn === 'N') {
        const params = {
          docId: docid,
          fileId: fileList[idx].fileId,
          brno: brno,
        }
        props.getDownLoad(params)
      }

      setTimeout(() => {
        let url = process.env.REACT_APP_API_URL + '/portal/file/edms/' + fileList[idx].contentId
        let xhr = new XMLHttpRequest()
        xhr.responseType = 'blob'
        xhr.open('GET', url)
        xhr.send()
        xhr.onload = function () {
          if (xhr.status === 200) {
            // HTTP가 잘 동작되었다는 뜻.
            setShowResponse(window.URL.createObjectURL(xhr.response))
            setBlobResponse(xhr.response)
            setShowFileNm(val['originFileNm'])
            setIsShowPdf(true)
            setDocid(docid)
            setCrtCd(crtCd)
            setBrno(brno)
            setOldYn('N')
            setFileId(fileList[idx].fileId)
            setPrintYn(fileList[idx].printYn)
          } else {
            props.error({ message: 'PDF 파일이 존재하지 않습니다.' })
            return
          }
        }
      }, 1000)
    })
  }

  return (
    <>
      <h3 className="h3-tit first">문서정보</h3>
      <table className="tbl-view">
        <caption>발급번호, 문서유형, 발급일시, 만료일시, 발급기관 항목으로 구성</caption>
        <colgroup>
          <col className="col1" />
          <col />
        </colgroup>
        <tbody>
          <tr>
            <th scope="row">발급번호</th>
            <td>{props.data?.docid}</td>
          </tr>
          <tr>
            <th scope="row">문서유형</th>
            <td>{props.commoncode?.CRT_DV?.find((co) => co.cd === props.data?.crtCd)?.cdName}</td>
          </tr>
          <tr>
            <th scope="row">발급일시</th>
            <td>
              {props.data?.issuedt === null || props.data?.issuedt === ''
                ? '-'
                : moment(props.data?.issuedt, 'YYYYMMDDHHmmss').format('YYYY.MM.DD HH:mm:ss')}
            </td>
          </tr>
          <tr>
            <th scope="row">만료일시</th>
            <td>
              {props.data?.crtfExpryDt === null || props.data?.crtfExpryDt === ''
                ? '-'
                : moment(props.data?.crtfExpryDt, 'YYYYMMDDHHmmss').format('YYYY.MM.DD HH:mm:ss')}
            </td>
          </tr>
          <tr>
            <th scope="row">발급기관</th>
            <td>{props.data?.prchsNm}</td>
          </tr>
        </tbody>
      </table>

      <h3 className="h3-tit first">일반정보</h3>

      <table className="tbl-view">
        <caption>
          인증번호, 신청자명, 휴대폰번호, Email, 업체명, 사업자등록번호, 업체주소, 공산품명, 제조국, 제조사제시모델명
          항목으로 구성
        </caption>
        <colgroup>
          <col className="col1" />
          <col />
        </colgroup>
        <tbody>
          <tr>
            <th scope="row">인증번호</th>
            <td>{gnrlInfoCn?.certification_no}</td>
          </tr>
          <tr>
            <th scope="row">신청자명</th>
            <td>{gnrlInfoCn?.aplcnt_nm}</td>
          </tr>
          <tr>
            <th scope="row">휴대폰번호</th>
            <td>{gnrlInfoCn?.mobile_no}</td>
          </tr>
          <tr>
            <th scope="row">Email</th>
            <td>{gnrlInfoCn?.email}</td>
          </tr>
          <tr>
            <th scope="row">업체명</th>
            <td>{gnrlInfoCn?.entrps_nm}</td>
          </tr>
          <tr>
            <th scope="row">사업자등록번호</th>
            <td>{gnrlInfoCn?.brno}</td>
          </tr>
          <tr>
            <th scope="row">업체주소</th>
            <td>{gnrlInfoCn?.entrps_addr}</td>
          </tr>
          <tr>
            <th scope="row">공산품명</th>
            <td>{gnrlInfoCn?.공산품명}</td>
          </tr>
          <tr>
            <th scope="row">제조국</th>
            <td>{gnrlInfoCn?.제조국}</td>
          </tr>
          <tr>
            <th scope="row">제조사제시모델명</th>
            <td>{gnrlInfoCn?.제조사제시모델명}</td>
          </tr>
          
        </tbody>
      </table>

      <h3 className="h3-tit">발급이력</h3>
      <table className="tbl-view">
        <caption>발급일자 항목으로 구성</caption>
        <colgroup>
          <col className="col1" />
          <col />
        </colgroup>
        <tbody>
          <tr>
            <th scope="row">발급일자</th>
            <td>{props.data?.issuedt && moment(props.data?.issuedt, 'YYYYMMDDhhmmss').format('YYYY.MM.DD')}</td>
          </tr>
        </tbody>
      </table>
      <div className="btn-block">
        <span className="right">
          {props.data?.fileGroupId !== null && props.data?.fileNewList?.length !== 0 && props.data?.fileNewList?.length === 1 && (
              <span className="attach-wrap">
                {props.data?.fileNewList?.map((fileObj, index) => (
                    <a
                        key={index}
                        href="#"
                        className="btn-primary md"
                        //className="attach attach-link"
                        onClick={(e) => {
                          e.preventDefault()
                          onPdfDown(props.data?.crtCd, props.data?.docid, gnrlInfoCn?.brno, fileObj)
                          return
                        }}
                    >
                      증명서 열람
                    </a>
                ))}
              </span>
          )}
          {props.data?.fileGroupId !== null && props.data?.fileNewList?.length !== 0 && props.data?.fileNewList?.length !== 1 && (
          <span className="attach-wrap">
            <a
              href="#"
              className="btn-primary md"
              //className="attach attach-link"
              onClick={(e) => {
                //e.preventDefault()
                //props.onPDFView()
                eventHandler(e, props.data?.crtSeq)
              }}
            >
              증명서 열람
            </a>
            <ul
              id={props.data?.crtSeq}
              // className={active === certboxObj.crtSeq + index ? 'attach-file active' : 'attach-file'}
              className='attach-file'
            >
              {props.data?.fileNewList?.map((fileObj, index) => (
                <li key={index}>
                  <a
                    onClick={(e) => {
                      e.preventDefault()
                      onPdfDown(props.data?.crtCd, props.data?.docid,gnrlInfoCn?.brno,fileObj)
                      onShowOut(e)
                      return
                    }}
                  >
                    {fileObj.originFileNm}
                  </a>
                </li>
              ))}
            </ul>
          </span>
          )}
          <a
            href="#"
            className="btn-secondary md"
            onClick={(e) => {
              e.preventDefault()
              props.goList()
            }}
          >
            목록
          </a>
        </span>
      </div>
      {isShowPdf === true && (
        <PdfViewer
          blobResponse={blobResponse}
          showResponse={showResponse}
          fileNm={showFileNm}
          crtCd={crtCd}
          docid={docid}
          brno={brno}
          oldYn={oldYn}
          fileId={fileId}
          printYn={printYn}
          onClose={() => setIsShowPdf(false)}
        />
      )}
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    commoncode: state.commoncode?.co,
  }
}

const actionCreators = {
  getCommonCode: commonActions.getCommonCode,
  getFile: certboxActions.getFile,
  error: alertActions.error,
  getDownLoad: certboxActions.getDownLoad,
}

export default connect(mapStateToProps, actionCreators)(CertboxForm5)
